import styles from './index.less';

import React, { useEffect, useState } from 'react';
import { listRights } from '@/services/athena';
import ProTable from '@ant-design/pro-table';
import moment from 'moment';
const OrderRight = (props) => {
  const { tenantId } = props;

  const columns = [
    {
      title: '订单编号',
      key: 'orderNo',
      dataIndex: 'orderNo',
      render: (text, record) => {
        return (
          <a
            href={`/operating/order?orderNo=${record.orderNo}`}
            target="_blank"
            className={styles.link}
          >
            {text}
          </a>
        );
      },
    },
    {
      title: '教练',
      key: 'phone',
      dataIndex: 'phone',
      render: (text, record) => {
        const { phone, userId } = record;
        return (
          <a
            href={`/user/record?id=${userId}&phone=${phone}`}
            target="_blank"
            className={styles.link}
          >
            {text}
          </a>
        );
      },
    },
    {
      title: '微信昵称',
      key: 'wxNickName',
      dataIndex: 'wxNickName',
    },
    {
      title: '权益价签',
      key: 'goodsPriceTag',
      dataIndex: 'goodsPriceTag',
    },
    {
      title: '购买时间',
      key: 'buyTime',
      dataIndex: 'buyTime',
      render: (text, record) => {
        return text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : '-';
      },
    },
    {
      title: '周期时长(天)',
      key: 'effectDays',
      dataIndex: 'effectDays',
    },
  ];

  return (
    <ProTable
      columns={columns}
      request={async (params) => {
        const { data, page, code } = await listRights({
          requestData: { ...params, tenantId },
          page: {
            currentPage: params.current,
            pageSize: params.pageSize,
          },
        });
        if (code !== '00000') {
          return {
            success: false,
          };
        }
        return {
          data: data,
          success: true,
          total: page.count,
        };
      }}
      toolbar={null}
      toolBarRender={false}
      scroll={{ x: 'max-content' }}
      rowKey={'id'}
      search={false}
      pagination={{
        defaultPageSize: 10,
      }}
      dateFormatter="string"
    />
  );
};

export default OrderRight;
